<template>
  <card class="job"  :footer="true" @click="showTalentProfile">
    <div class="media" >
      <div class="media-left is-relative">
        <hv-image :src="imageUrl" size="is-64x64" >
        </hv-image>
      </div>
      <div class="media-content">
      </div>
      <div class="media-right has-text-right">
        <h2 class="is-salary is-5 m-b-8" >
<!--          <job-salary :job="job" />-->
          {{this.$t('widget.available')}}
        </h2>
        <h4 class="subtitle is-7 m-b-12">{{this.$t('widget.permanentAndContract')}}</h4>
      </div>
    </div>
    <h2 class="job-title text-overflow m-b-12">{{name}}</h2>
    <p v-if="role" class="company m-b-4">{{role}}</p>
    <p v-else class="company m-b-4"></p>
    <p v-if="user.location">{{user.location}}</p>
    <p v-else class="m-b-20"></p>
    <template slot="footer">
      <split-section>
        <template slot="left">
          <div class="segment">
            <p><strong>{{this.$t('widget.salaryMin')}}</strong> </p>
            <p>{{salary}}</p>
          </div>
        </template>
        <template slot="right">
          <div class="segment" >
            <p><strong>{{this.$t('widget.noticePeriod')}}</strong></p>
            <p>{{noticePeriod}}</p>
          </div>
        </template>
      </split-section>
    </template>
  </card>
</template>

<script>
import Card from '@/components/general/card'
import SplitSection from '@/components/general/split-section'
import HvImage from '@/components/general/image'
import Currency from '@/components/general/currency'
import GlobalData from '@/helpers/global-data'
import JobLocation from '../jobs/job-locations'

export default {
  name: 'UserCard',
  components: {
    Card,
    SplitSection,
    HvImage,
    GlobalData,
    Currency,
    JobLocation
  },
  data () {
    return {
    }
  },
  props: {
    user: {
      type: Object
    },
    cardClick: {
      type: Function
    },
    notWidget: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    name () {
      return this.user.firstName + ' ' + this.user.lastName
    },
    imageUrl () {
      return this.user.profilePictureUrl || `/api/identicons/${this.user.id}`
    },
    role () {
      return this.notWidget ? this.user.role : this.user.role
    },
    noticePeriod () {
      return this.user.noticePeriod ? `${this.user.noticePeriod} Days` : this.$t('widget.undisclosed')
    },
    salary () {
      return this.user.salary ? `$ ${this.user.salary}` : this.$t('widget.undisclosed')
    }
  },
  methods: {
    showTalentProfile () {
      if (this.notWidget) {
        this.cardClick(this.user)
      } else {
        if (this.user.hasOwnProperty('id') && this.user.id) {
          window.open(`${window.location.origin}/jobseekers/${this.user.id}`, '_blank')
        } else if (this.user.hasOwnProperty('userId') && this.user.userId) {
          window.open(`${window.location.origin}/jobseekers/${this.user.userId}`, '_blank')
        }
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.job {
  cursor: pointer;
}

.job:hover {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
}
.segment {
  line-height: 1;
}
.job-title {
  font-size: 1.25rem;
  font-weight: 500;
}
p.company {
  font-size: 0.875rem;
  height: 16px;
  overflow: hidden;
  font-weight: bold;
  a {
    color: #111;
  }
}
p.is-7 {
  font-size: 0.75rem;
  margin-top: 0.25rem;
}
strong {
  font-size: 0.75rem;
  display: block;
  margin-bottom: 0.25rem;
}
.is-7 {
  margin-top: 0;
  color: #111;
  font-size: 0.75rem;
}
.status-label {
  color: #111111;
  font-weight: bold;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/general/user-card.vue